import React, { ReactNode } from 'react';

import { Tooltip, TooltipProps, Stack, Box, Question24 } from 'Modules/ui3';


type HelpTooltipProps = Omit<TooltipProps, 'title' | 'children' | 'text'> & {
    label: ReactNode;
    tooltipText: ReactNode;
    size?: number;
    iconSize?: number;
    spacing?: number;
};

export const HelpTooltip: React.FC<HelpTooltipProps> = ({
    label,
    tooltipText,
    size = 20,
    iconSize = 16,
    spacing = 4,
    placement = 'top-start',
    ...props
}) => (
    <Stack direction='row' spacing={spacing}>
        <span>{label}</span>
        <Tooltip text={tooltipText} placement={placement} {...props}>
            <Box
                bgcolor='grayscale.shade10'
                borderRadius='50%'
                display='flex'
                alignItems='center'
                justifyContent='center'
                width={size}
                height={size}
            >
                <Question24
                    sx={{
                        color: 'grayscale.shade85',
                        fontSize: iconSize,
                    }}
                />
            </Box>
        </Tooltip>
    </Stack>
);
